import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsSchedulingRoute: InvariantJiraRoute = {
	name: 'plan-settings-scheduling',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/scheduling',
};
